(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  /* Toggle dropdowns & autocomplete filter */
  document.addEventListener('click', (e) => {
    const filterBtn = e.target.closest('[data-action="toggle-filters"]');
    const sortBtn = e.target.closest('[data-action="toggle-sort"]');
    const filterDropdown = document.querySelector('.vb-blog-toolbar__dropdown');
    const sortOpts = document.querySelector('.vb-blog-toolbar__sort-options');
    const searchInput = document.querySelector('.vb-blog-toolbar__search');

    if (filterBtn) {
      const isHidden = filterDropdown.hidden;
      filterDropdown.hidden = !isHidden;
      if (sortOpts) sortOpts.hidden = true;
      if (!isHidden === false && searchInput) {
        searchInput.value = '';
        filterResults('');
        searchInput.focus();
      }
      return;
    }

    if (sortBtn) {
      const isHidden = sortOpts.hidden;
      sortOpts.hidden = !isHidden;
      if (filterDropdown) filterDropdown.hidden = true;
      return;
    }

    /* Close dropdowns when clicking outside */
    if (!e.target.closest('.vb-blog-toolbar')) {
      if (filterDropdown) filterDropdown.hidden = true;
      if (sortOpts) sortOpts.hidden = true;
    }
  });

  /* Autocomplete search */
  function filterResults(query) {
    const results = document.querySelectorAll('.vb-blog-toolbar__result');
    const q = query.toLowerCase().trim();
    results.forEach(el => {
      const tag = el.getAttribute('data-tag');
      el.style.display = (!q || tag.includes(q)) ? '' : 'none';
    });
  }

  const searchInput = document.querySelector('.vb-blog-toolbar__search');
  if (searchInput) {
    searchInput.addEventListener('input', (e) => {
      filterResults(e.target.value);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-limited"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vb-blog-article-toc"] && !Shopify.designMode) return;
  try {
    
  const toc = document.getElementById('vb-toc');
  if (toc) {
    const toggle = toc.querySelector('.vb-toc__toggle');
    const panel = toc.querySelector('.vb-toc__panel');
    const list = toc.querySelector('.vb-toc__list');

    /* Build TOC from article headings */
    const content = document.querySelector('.blog-post-content');
    if (content) {
      const headings = content.querySelectorAll('h2, h3');
      if (headings.length < 2) {
        toc.style.display = 'none';
      } else {
        headings.forEach((h, i) => {
          const id = 'toc-' + i;
          h.id = id;
          const li = document.createElement('li');
          li.className = 'vb-toc__item' + (h.tagName === 'H3' ? ' vb-toc__item--sub' : '');
          const a = document.createElement('a');
          a.href = '#' + id;
          a.textContent = h.textContent;
          a.addEventListener('click', (e) => {
            e.preventDefault();
            h.scrollIntoView({ behavior: 'smooth', block: 'start' });
            panel.hidden = true;
            toggle.setAttribute('aria-expanded', 'false');
          });
          li.appendChild(a);
          list.appendChild(li);
        });
      }
    }

    /* Toggle panel */
    toggle.addEventListener('click', () => {
      const isHidden = panel.hidden;
      panel.hidden = !isHidden;
      toggle.setAttribute('aria-expanded', String(isHidden));
    });

    /* Close on click outside */
    document.addEventListener('click', (e) => {
      if (!toc.contains(e.target)) {
        panel.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
      }
    });

    /* Show/hide TOC based on scroll position (only visible in article content area) */
    function updateTocVisibility() {
      if (!content) return;
      const rect = content.getBoundingClientRect();
      const inView = rect.top < window.innerHeight && rect.bottom > 100;
      toc.classList.toggle('vb-toc--visible', inView);
    }

    updateTocVisibility();
    window.addEventListener('scroll', updateTocVisibility, { passive: true });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vb-collection-description"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var content = document.getElementById('collection-description-content');
    var toggle = document.getElementById('collection-description-toggle');
    if (!content || !toggle) return;

    // Hide toggle and fade if content fits without clipping
    if (content.scrollHeight <= content.offsetHeight + 2) {
      toggle.classList.add('is-hidden');
      content.classList.add('is-short');
      return;
    }

    toggle.addEventListener('click', function() {
      var expanded = content.classList.toggle('is-expanded');
      toggle.setAttribute('aria-expanded', expanded);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vb-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var accordions = document.querySelectorAll('.vb-faq__accordion');
    accordions.forEach(function (accordion) {
      accordion.addEventListener('click', function (e) {
        var button = e.target.closest('.vb-faq__question');
        if (!button) return;

        var item = button.closest('.vb-faq__item');
        var answer = item.querySelector('.vb-faq__answer');
        var isOpen = button.getAttribute('aria-expanded') === 'true';

        button.setAttribute('aria-expanded', !isOpen);
        if (isOpen) {
          answer.classList.remove('vb-faq__answer--open');
        } else {
          answer.removeAttribute('hidden');
          /* Force reflow before adding class for transition */
          answer.offsetHeight;
          answer.classList.add('vb-faq__answer--open');
        }

        /* After close transition, re-add hidden for accessibility */
        if (isOpen) {
          answer.addEventListener('transitionend', function handler() {
            if (!answer.classList.contains('vb-faq__answer--open')) {
              answer.setAttribute('hidden', '');
            }
            answer.removeEventListener('transitionend', handler);
          });
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
